'use strict';

function isFlaggedRedirect(redirect) {
    return typeof redirect.flag === "string";
}
function assertPlainRedirect(redirect) {
    if (typeof redirect.flag !== "undefined") {
        throw new Error("Redirect is not a plain redirect");
    }
}
function syncMatchRedirect(path, redirects) {
    for (const redirect of redirects) {
        if (matchPattern(redirect.from, path)) {
            return redirect;
        }
    }
    return undefined;
}
async function matchRedirect(path, redirects, ldClient) {
    for (const redirect of redirects) {
        if (matchPattern(redirect.from, path)) {
            if (isFlaggedRedirect(redirect)) {
                if (ldClient) {
                    // TODO: pass in userId to variation call
                    const isEnabled = await ldClient.variation(redirect.flag, { key: "anonymous" }, false);
                    if (isEnabled) {
                        return {
                            from: redirect.from,
                            to: redirect.to,
                            permanent: redirect.permanent,
                            preserveQueryString: redirect.preserveQueryString,
                        };
                    }
                }
                // if flag evaluated to false, or ld client is not available
                // continue evaluating
                continue;
            }
            else {
                assertPlainRedirect(redirect);
                return redirect;
            }
        }
    }
    return undefined;
}
/**
 * Check if pathname is a match against pattern
 * @param pattern - A URL pathname pattern, may contain wildcard (`*`) at the end
 * @param pathname  - URL pathname to check for match
 * @returns true if the pathname matches with the pattern
 *
 * @internal
 */
function matchPattern(pattern, pathname) {
    if (pattern.includes("?") || pattern.includes("#")) {
        throw new Error(`Invalid pattern: ${pattern} patterns cannot include ? or #`);
    }
    if (pattern.endsWith("*")) {
        return pathname.startsWith(pattern.slice(0, -1));
    }
    return pathname === pattern;
}

exports.matchRedirect = matchRedirect;
exports.syncMatchRedirect = syncMatchRedirect;
//# sourceMappingURL=index.cjs.map
